import { render, staticRenderFns } from "./addressDialog.vue?vue&type=template&id=630930af&scoped=true"
import script from "./addressDialog.vue?vue&type=script&lang=js"
export * from "./addressDialog.vue?vue&type=script&lang=js"
import style0 from "./addressDialog.vue?vue&type=style&index=0&id=630930af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630930af",
  null
  
)

export default component.exports